import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { DrawRequestStatus } from '../types';

const EMPTY_LIST = [];
const IN_REVIEW_STATUSES = [
  DrawRequestStatus.SUBMITTED,
  DrawRequestStatus.UNDER_REVIEW,
  DrawRequestStatus.INSPECTION,
];

const selectConstructionRoot = state => state.construction;

const selectConstructionByApplication = createSelector(
  selectConstructionRoot,
  ({ constructionByApplication }) => constructionByApplication,
);

const selectApplicationConstruction = memoizeOne(applicationId =>
  createSelector(selectConstructionByApplication, byApplication => byApplication[applicationId]),
);

export const selectConstructionBudget = memoizeOne(applicationId =>
  createSelector(
    selectApplicationConstruction(applicationId),
    applicationState => applicationState?.budget ?? null,
  ),
);

export const selectConstructionBudgetLines = memoizeOne(applicationId =>
  createSelector(selectConstructionBudget(applicationId), budget => budget?.lines ?? EMPTY_LIST),
);

export const selectDrawRequests = memoizeOne(applicationId =>
  createSelector(
    selectApplicationConstruction(applicationId),
    applicationState => applicationState?.drawRequests ?? EMPTY_LIST,
  ),
);

export const selectDrawRequestById = memoizeOne(({ applicationId, drawRequestId }) =>
  createSelector(selectDrawRequests(applicationId), drawRequests =>
    drawRequests.find(drawRequest => drawRequest.id === drawRequestId),
  ),
);

// The "current" draw is the earliest one still in an actionable review state — the one the
// summary review pane surfaces above the full draw history.
export const selectCurrentDrawRequest = memoizeOne(applicationId =>
  createSelector(
    selectDrawRequests(applicationId),
    drawRequests =>
      drawRequests.find(drawRequest => IN_REVIEW_STATUSES.includes(drawRequest.status)) ?? null,
  ),
);
